export function ConsentsCollapseInit() {
    const buttonsQuery = '#custom_consent_fields .c-show-more-less';

    /**
     * @type NodeListOf
     */
    const showHideButtons = document.querySelectorAll(buttonsQuery);

    showHideButtons.forEach(bt => bt.addEventListener('click', (event) => {
        const fieldId = event.target.id.replace('_show-more-less', '');
        const fieldLabelId = fieldId + '_label';
        const labelEl = document.getElementById(fieldLabelId);
        if (labelEl) {
            if (labelEl.classList.contains("collapsed")) {
                labelEl.classList.remove("collapsed");
                event.target.innerText = "Mniej"
            } else {
                labelEl.classList.add("collapsed");
                event.target.innerText = "Więcej"
            }
        }

    }))

}

